import type * as React from 'react'
import { cn } from '../lib/cn.js'

export interface SwitchProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onChange' | 'value'> {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}

/**
 * An on/off toggle for a single state, not a plural selection — that's what a
 * checkbox is for. Used where "active" or "enabled" needs to read at a
 * glance, next to a table's row-selection checkboxes rather than looking like
 * one of them.
 */
export function Switch({ checked, onCheckedChange, disabled, className, ...props }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={cn(
        'relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border border-transparent transition-colors duration-150 disabled:pointer-events-none disabled:opacity-50',
        checked ? 'bg-primary' : 'bg-surface-sunken border-border',
        className,
      )}
      {...props}
    >
      <span
        className={cn(
          'pointer-events-none inline-block size-3.5 translate-x-0.5 rounded-full bg-white shadow-xs transition-transform duration-150',
          checked && 'translate-x-[18px]',
        )}
      />
    </button>
  )
}
